import React from 'react'
import { graphql } from 'gatsby'
import Layout from '@layout'
import SEO from '@layout/SEO'
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews'
import { LinkResolver } from '../../utils/LinkResolver'
import { DateDisplay, FullDate }  from '@utils/DateDisplay'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ContentBreadcrumb from '@components/ContentItem/ContentBreadcrumb'
import MainContentDisplay from '@components/ContentItem/MainContentDisplay'
import ContentCategory from '@components/ContentItem/ContentCategory'
import ItemSubjects from '@components/ContentItem/ItemSubjects'
import DocumentDesignation from '@components/ContentItem/DocumentDesignation'
import Versions from '@components/ContentItem/Versions'
import RelatedContent from '@components/ContentItem/RelatedContent'
import './styles.css'
import researchLogo from '../../images/logo.png'

// Query for the content in Prismic
export const query = graphql`
query ContentQuery ($uid: String){
  prismicContent( uid: { eq: $uid }) { 
            _previewable
            uid
            id
            type
            url
            data {
              title
              source
              content_item_path
              date_published
              description
              document_designation
              content_category
              content_category_has_landing_page
              content_category_link{
                type
                uid
                url
              }
              resource_type
              content {
                text
                html
                raw
              }
              historical
              thumbnail {
                alt
                url
                thumbnails {
                  horizontal {
                    alt 
                    url
                  }
                  small {
                    alt
                    url
                  }
                }
              }
              has_text_only_version
              text_only_file_name
              featured
              related_content_items {
                related_content {
                  uid
                  url
                  type
                  document {
                    ...on PrismicContent {
                      id
                      data {
                        title
                      }
                    }
                  }
                }
              }
              body {
                ... on PrismicContentDataBodySubjects {
                  id
                  items {
                    subject {
                      uid
                      type
                      url
                      document {
                        ... on PrismicSubject {
                          id
                          _previewable
                          url
                          data {
                            subject_name
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          
          }
}
`

const ContentItem = (props) => {
  // Define the content returned from Prismic
  const doc = props.data.prismicContent;
  if(!doc) return null;

  if (typeof window !== "undefined"){
 
    return(
        <Layout>
            <SEO title={doc.data.title}  pathname={props.location.pathname}/>
            <Row>
              <Col>
                <ContentBreadcrumb item={doc}/>
                <div className="print-logo">
                  <img src={researchLogo} alt="Research Division Logo. State of Nevada shape to the left of the words 'Research Division, Legislative Counsel Bureau, Connecting People to Policy'" className="logo-img img-fluid" />
                </div>
                <h1>{doc.data.title ? doc.data.title : ""}</h1> 
                <p className="mb-0">{doc.data.source ? doc.data.source + " | " : ""} {doc.data.date_published ? FullDate(doc.data.date_published) : ""}</p>
                <hr/>          
              </Col>
            </Row>
            <Row>
              <Col lg={9} className="content-item-body order-2 order-md-1">
                <MainContentDisplay doc={doc}/>
                <RelatedContent relatedContent={doc.data.related_content_items}/> 
              </Col>
              <Col lg={3} className="order-1 order-md-2">
                <Versions item={doc}/>
                <ItemSubjects subjects={doc.data.body[0]} />
                <ContentCategory item={doc}/>
                <DocumentDesignation designation={doc.data.document_designation}/>
              </Col>
            </Row> 
        </Layout>
    )
  }
  else {
    return null;
  }
  
}

export default withPrismicPreview(ContentItem, [{
  repositoryName: 'lcb-research',
  linkResolver: LinkResolver
}]);